import {H2, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Grid} from '@/grid';
import {withBgYellow50} from '@/hocs/withColors';
import {withMarginBottomXs} from '@/hocs/withSpacing';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';

const Yellow50Section = withBgYellow50(SectionPadding);
const H2MarginBottomXs = withMarginBottomXs(H2);

const SecurityExternalLinks = [
  {
    title: 'Proactive security management',
    copy: 'Our dedicated security team operates across four key pillars: security assessment and simulation, threat prevention and detection, compliance management, and security awareness.'
  },
  {
    title: 'Real-time monitoring and response',
    copy: '24/7/365 security monitoring of all production resources, with automated alerts ensuring immediate response to security events.'
  },
  {
    title: 'Multi-layer application security',
    copy: 'Industry-leading protection through web application firewalls, DDoS prevention, and hardened TLS configuration. All new features undergo security validation with automated vulnerability scanning in our CI/CD pipeline.'
  }
];

const SecurityDataSection = () => (
  <Yellow50Section>
    <Container>
      <Grid fluid>
        <GridLayout Col={3} lgCol={2} autoRows>
          {SecurityExternalLinks.map((item, index) => (
            <GridItem key={index}>
              <BoxGrid backgroundColor="var(--yellow100)">
                <H2MarginBottomXs className="heading-3">{item.title}</H2MarginBottomXs>
                <PNoMargin>{item.copy}</PNoMargin>
              </BoxGrid>
            </GridItem>
          ))}
        </GridLayout>
      </Grid>
    </Container>
  </Yellow50Section>
);

export default SecurityDataSection;
